import usePostalAddressSync from '@/hooks/usePostalAddressSync';
import { Grid, Typography } from '@mui/material';
import { Checkbox, InputOnlyField, Text } from '@ngt/forms';
import { FC } from 'react';

const columnMapping = {
    xs: 12,
    sm: 6,
    md: 3
}

interface PostalAddressFieldsProps {
    showPostalHeading?: boolean;
}

const PostalAddressFields: FC<PostalAddressFieldsProps> = ({ showPostalHeading = true }) => {
    const {sameAsAddress, sameStateAsAddress} = usePostalAddressSync();

    //note that the state field in this form is a string, not an index like the main address state field
    //i assume this is because if their postal country is different to their main country, they need to be able to enter a non-australian state

    return (
        <>
            {showPostalHeading && (
                <Grid  
                    item
                    sm={12}
                >
                    <Typography variant='h2'>
                        Postal
                    </Typography>
                </Grid>
            )}

            <Grid item xs={12}>
                <InputOnlyField
                    label={showPostalHeading ? "Address Same as Above" : "Address Same as Institution Address"}
                    propertyPath="addressSame"
                    component={Checkbox}
                />
            </Grid>

            <Grid item {...columnMapping}>
                <InputOnlyField
                    label="Postal Street"
                    propertyPath="postalStreet"
                    component={Text}
                    variant="standard"
                    margin="normal"
                    disabled={sameAsAddress}
                />
            </Grid>
            <Grid item {...columnMapping}>
                <InputOnlyField
                    label="Postal Suburb"
                    propertyPath="postalSuburb"
                    component={Text}
                    variant="standard"
                    margin="normal"
                    disabled={sameAsAddress}
                />
            </Grid>
            <Grid item {...columnMapping}>
                <InputOnlyField
                    label="Postal Postcode"
                    propertyPath="postalPostcode"
                    component={Text}
                    variant="standard"
                    margin="normal"
                    disabled={sameAsAddress}
                />
            </Grid>
            <Grid item {...columnMapping}>
                <InputOnlyField
                    label="Postal State"
                    propertyPath="postalState"
                    component={Text}
                    variant="standard"
                    margin="normal"
                    disabled={sameStateAsAddress}
                />
            </Grid>
            <Grid item {...columnMapping}>
                <InputOnlyField
                    label="Postal Country"
                    propertyPath="postalCountry"
                    component={Text}
                    variant="standard"
                    margin="normal"
                    disabled={sameAsAddress}
                />
            </Grid>
        </>
    );
}

export default PostalAddressFields;
